// extracted by mini-css-extract-plugin
export default {"tabs":"M9-z","tablist":"N9-z","tablistItem":"O9-z"};